import { SurveyComponent } from "../../survey_component";
import env from "../../../../env";

const required = env.ENDPOINT !== "local";

export const OtherQuestionRelativeKnown = new SurveyComponent({
  name: "other_question_relative_known",
  type: "radiogroup",
  isRequired: required,
  title: {
    en: "Do you have a family member who is one of our applicants or guarantors? *",
    ar: "هل أحد أفراد الأسرة عميل أو كفيل لدينا؟ *"
  },
  choices: [
    {
      value: true,
      text: {
        en: "Yes",
        ar: "نعم"
      }
    },
    {
      value: false,
      text: {
        en: "No",
        ar: "لا"
      }
    }
  ]
});
